import React from 'react';
import DashboardSubheader from '../../DashboardSubheader';
import { HelpCircle } from 'lucide-react';

interface SectionHeaderProps {
  header: string;
  subheader?: string;
  helpTips?: string;
}
const SettingsSectionHeader = ({
  header,
  helpTips,
  subheader,
}: SectionHeaderProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-start gap-2 w-fit">
        <DashboardSubheader>{header}</DashboardSubheader>
        {/* HELP TIP */}
        {helpTips && (
          <div className="p-1  relative group cursor-pointer">
            <HelpCircle className="size-4 md:size-5 medium-emphasis-text" />
            <small className="mt-1/2 w-40 p-2 top-[90%] hover:top-[110%] group-hover:top-[100%] -right-2 hover:visible opacity-0 hover:opacity-100 group-hover:opacity-100 group-hover:visible invisible transition-all duration-300 absolute text-gray-100 rounded-md bg-gray-800 border border-gray-800 shadow-lg block">
              {helpTips}
            </small>
          </div>
        )}
      </div>
      <p className="medium-emphasis-text">{subheader}</p>
    </div>
  );
};

export default SettingsSectionHeader;
